import { TSAircraft } from '@pelicargo/types';
import { InstantSearch } from 'react-instantsearch-hooks';

import { useTypesense } from '../../hooks/useTypesense';
import { InputAutocomplete, InputProps } from './InputAutocomplete';

export const AircraftInput = ({
  valueKey = 'aircraft_name',
  ...props
}: InputProps & { valueKey?: Extract<keyof TSAircraft, 'id' | 'aircraft_name'>; label?: string }) => {
  const { searchClient } = useTypesense({
    additionalSearchParameters: {
      query_by: 'aircraft_name',
    },
  });

  if (!searchClient) return null;

  return (
    <InstantSearch searchClient={searchClient} indexName="aircrafts">
      <InputAutocomplete<TSAircraft>
        hitMap={(hits) =>
          hits.map((hit) => ({
            label: hit.aircraft_name,
            value: hit[valueKey],
          }))
        }
        {...props}
      />
    </InstantSearch>
  );
};
